"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
const sdk_1 = require("../sdk");
var Status;
(function (Status) {
    Status.status = () => {
        const url = `/status`;
        return sdk_1.SDK.axios.get(url);
    };
    Status.m2m = () => {
        const url = `/status/m2m`;
        return sdk_1.SDK.axios.get(url);
    };
    Status.svcustomer = () => {
        const url = `/status/svcustomer`;
        return sdk_1.SDK.axios.get(url);
    };
    Status.svinmate = () => {
        const url = `/status/svcustomer`;
        return sdk_1.SDK.axios.get(url);
    };
})(Status = exports.Status || (exports.Status = {}));
//# sourceMappingURL=status.js.map